var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInkDropL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.83 41.49c-2.46-7.13-13.17-21.77-13.62-22.39a1.54 1.54 0 00-2.42 0c-.45.62-11.16 15.26-13.62 22.39A14.67 14.67 0 0024.5 46a15.5 15.5 0 0031 0 14.67 14.67 0 00-.67-4.51z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h80v80H0z"
  })));
}

export default SvgIconInkDropL;